import { Stack, Typography } from '@mui/material';

import AppModal from '@common/ui/AppModal';

import { AccessFlowSelectionContent } from './ui/AccessFlowSelectionContent';
import { useLogic } from './useLogic';

export function AccessFlowSelectionModal() {
  const {
    isOpen,
    selectedScope,
    isFetched,
    filteredAccessFlows,
    searchTerm,
    setSearchTerm,
    handleClose,
    createNewFlowPath,
  } = useLogic();

  const ModalHeader = (
    <Stack direction="column">
      <Typography variant="subtitle1">Select Access Flow for Scope</Typography>
      {selectedScope && (
        <Typography variant="body2" color="text.muted">
          {selectedScope?.name}
        </Typography>
      )}
    </Stack>
  );

  return (
    <AppModal header={ModalHeader} open={isOpen} onClose={handleClose} width={860}>
      {selectedScope ? (
        <AccessFlowSelectionContent
          selectedScopeId={selectedScope.id}
          isFetched={isFetched}
          filteredAccessFlows={filteredAccessFlows}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          onClose={handleClose}
          createNewFlowPath={createNewFlowPath}
        />
      ) : (
        <Typography>Please select an Access Scope first</Typography>
      )}
    </AppModal>
  );
}
